import { FormattedMessage } from 'react-intl';
import { Schedule } from '@/features/accounts/types';
import { type ScheduleControls } from '@/features/accounts/schedule/hooks/useScheduleControls';
import Button from '@/shared/components/Button';

interface Props {
  schedule: Schedule;
  actions: ScheduleControls;
}

export default function MonitorButton({ schedule, actions }: Props) {
  if (!schedule.bookable) {
    return null;
  }

  if (schedule.status === 'paused') {
    return (
      <Button variant="outline-success" size="sm" fullWidth onClick={() => actions.activate(schedule)}>
        <FormattedMessage id="schedule.list.activate" />
      </Button>
    );
  }

  if (schedule.reactivatable) {
    return (
      <Button variant="outline-success" size="sm" fullWidth onClick={() => actions.reactivate(schedule)}>
        <FormattedMessage id="schedule.list.reactivate" />
      </Button>
    );
  }

  return null;
}
